/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useDispatch } from 'react-redux'
import { Dispatch } from '@reduxjs/toolkit'
import { useAuth } from '../modules/auth'
import { updateCardById } from '../services/cards'
import {
  upsertCurrentUserCard,
  upsertBoardCard,
} from '../store/slice/card-slice'
import { upsertSearchCard } from '../store/slice/home-searching-slice'

/**
 * Push a checklist item's due date+time to its linked task card.
 *
 * Mirrors useTaskAssigneeSync — the picker's selection IS the source of
 * truth. Pass null to clear. Both fields move together (a card with one
 * but not the other is treated as "no due date" by every consumer).
 */
export function useTaskDueDateSync() {
  const dispatch: Dispatch<any> = useDispatch()
  const { currentUser } = useAuth()
  const { id: userId, fullName } = currentUser?.data?.user || {}


  return async (
    taskId: string,
    due: { due_date: string | null; due_time: string | null },
    taskCard: any
  ): Promise<boolean> => {
    if (!taskCard?.boardId || !userId) return false
    const sameValue =
      (taskCard.due_date ?? null) === (due.due_date ?? null) &&
      (taskCard.due_time ?? null) === (due.due_time ?? null)
    if (sameValue) return false

    // Optimistic upsert FIRST — the editor's redux→DOM sync effect runs
    // again as soon as the editor re-renders, and treats the task as
    // authoritative. If we awaited the API before dispatching, the
    // effect would see the in-flight task with its old due date and
    // overwrite the new value we just wrote to the item DOM, which
    // surfaces as "Save shows old data".
    const next = {
      ...taskCard, due_date: due.due_date, due_time: due.due_time
    }
    dispatch(upsertCurrentUserCard(next))
    dispatch(upsertBoardCard(next))
    dispatch(upsertSearchCard(next))

    try {
      await updateCardById(
        {last_modified_by: fullName,
      created_by: taskCard.created_by ?? fullName,
      board_name: taskCard.board_name.trim(),
      card_name: taskCard.card_name,
      boardId: taskCard.boardId,
      board_column_id: taskCard.board_column_id,  due_date: due.due_date, due_time: due.due_time },
        taskId,
        userId,
        taskCard.boardId
      )
      return true
    } catch {
      // Roll back the optimistic upsert so the UI reflects reality.
      dispatch(upsertCurrentUserCard(taskCard))
      dispatch(upsertBoardCard(taskCard))
      dispatch(upsertSearchCard(taskCard))
      return false
    }
  }
}
